<template>
    <div class="login">
        <div class="login_img">
            <img src="../assets/login/bg_logo.png" alt="" calss="logo" style="border-radius: 50%; margin-top: 10px;"/>
            <div class="text">
                <h1>信泽金服</h1>
                <h2>核心信贷业务系统</h2>
            </div>
        </div>
        <div class="login_da">
            <div class="login_da_useb"><span style="color: red;">{{errorMsg}}</span></div>
            <div class="login_da_use">
                <span><img src="../assets/login/ic_use.png" alt=""/></span>
                <input ref="account" v-model="username" type="text" placeholder="请输入登录账号">
            </div>
            <div class="login_da_use">
                <span><img src="../assets/login/ic_psd.png" alt=""/></span>
                <input ref="password" v-model="password" type="password" placeholder="请输入登录密码">
            </div>
            <!-- <div class="login_da_gou">
               <input ref="remember_account" type="checkbox" checked="checked">
               <span>记住用户名和密码</span>
             </div>-->
            <div class="login_btn">
                <a @click="doLogin">登录</a>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import {login} from '@/api/login'
    import {mapActions} from 'vuex'

    export default {
        name: 'login',
        data() {
            return {
                validateCode: '',
                password: '',
                username: '',
                errorMsg: ''
            }
        },
        components: {},
        mounted() {

        },
        methods: {
            ...mapActions(['Login']),
            doLogin() {
                //this.$router.push({ path: '/home' })
                if(!this.username){
                    this.$toast('请输入登录账号')
                }
                if(!this.password){
                    this.$toast('请输入密码')
                }
                let data = {
                    username: this.username,
                    password: this.password
                }
                this.Login(data).then(res => {
                    if (res.statusCode == 'success') {
                        this.$router.push({path: '/home'})
                    } else {
                        this.$toast(res.message)
                    }
                }).catch(err => {
                })
            }
        }
    }
</script>

<style>
    /* login*/
    html {
        height: 100%;
        width: 100%;
    }

    body {
        width: 100%;
        height: 100%;
        overflow: auto;
        font-size: 0.8rem;
        font-family: Arial, Helvetica, STHeiTi, sans-serif;
        word-break: break-all;
    }

    .login {
        background: url('../assets/login/bg.jpg') no-repeat center top #f1f1f1;
        background-size: 16rem 7.125rem;
        vertical-align: top;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .login_img {
        width: 100%;
        margin: 5rem auto 0 auto;
        text-align: center;
    }

    .login_img img {
        width: 7rem;
    }
    .text{
        margin-top: -8px;
    }
    .text h1 {
        font-size: 20px;
        margin: 10px 0 5px;
        color: #000;
    }

    .text h2 {
        font-size: 16px;
        margin: 5px 0 0;
        color: #555;
    }

    .login_da {
        width: 100%;
        height: auto;
        overflow: hidden;
        font-size: 1rem;
    }

    .login_da .login_da_use {
        margin: 0 auto;
        width: 65%;
        border-bottom: 1px solid #d6d5d3;
        height: 2.0rem;
        padding: 0.5rem 0;
        margin-top: 0.2rem;
    }

    .login_da .login_da_use span {
        float: left;
        height: 2.0rem;
        line-height: 2.0rem;
        margin-top: 0.3rem;
    }

    .login_da .login_da_useb {
        margin: 0 auto;
        width: 65%;
        height: 0.5rem;
        padding: 0.2rem 0;
    }

    .login_da .login_da_useb span {
        float: left;
        height: 0.5rem;
        line-height: 0.5rem;
    }

    .login_da .login_da_use span img {
        width: 1.2rem;
        height: 1.2rem;
        text-align: center;
    }

    .login_da .login_da_use input {
        border: medium none;
        color: #000;
        font-size: 1rem;
        height: 2.0rem;
        width: 80%;
        line-height: 2.0rem;
        float: left;
        background: none;
        margin-left: 0.5rem;
    }

    .login_da_use02 {
        margin: 0 auto;
        width: 65%;
        border-bottom: 1px solid #d6d5d3;
        height: 2.0rem;
        padding: 0.5rem 0;
        margin-top: 0.5rem;
    }

    .login_da_use02 span {
        float: left;
        height: 2.3rem;
        line-height: 2.3rem;
        margin-top: 0.125rem;
    }

    .login_da_use02 span img {
        width: 1.2rem;
        height: 1.2rem;
        text-align: center;
    }

    .login_da_use02 input {
        border: medium none;
        color: #b4b4b4;
        font-size: 1rem;
        height: 2.0rem;
        width: 55.5%;
        line-height: 2.0rem;
        float: left;
        background: none;
        margin-left: 0.5rem;
    }

    .login_da_use02 a {
        width: 3rem;
        height: 2.0rem;
        float: left;
    }

    .login_da_use02 a img {
        width: 4rem;
        height: 2.2rem;
    }

    .login_da_gou {
        margin: 0 auto;
        width: 65%;
        height: 2.5rem;
        padding: 0.5rem 0;
        margin-top: 0.5rem;
    }

    .login_da_gou span {
        float: left;
        font-size: 1rem;
        margin-left: 0.5rem;
    }

    .login_da_gou input {
        border: medium none;
        border: 1px solid #eee;
        width: 1rem;
        height: 1rem;
        float: left;
        margin-top: 0.2rem;
    }

    .login_btn {
        margin: 0 auto;
        width: 100%;
        height: auto;
        overflow: hidden;
        margin-top: 20px;
    }

    .login_btn a {
        background: #faab08 none repeat scroll 0 0;
        border-radius: 100px;
        color: #fff;
        font-size: 1rem;
        text-align: center;
        width: 15rem;
        height: 2.8rem;
        display: block;
        margin: 0 auto;
        line-height: 2.8rem;
    }
</style>
